export default __webpack_public_path__ + "static/media/ten.08477bc6.mp3";